
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.interior-hero.bg-light-gray {

    background-image: var(--bh-gradient-gray-b-t);
}

  .interior-hero.bg-light-gray .interior-hero-eyebrow {

    font-weight: var(--fw-bold);
}

  @media (min-width: 1024px) {

    .interior-hero.bg-light-gray .interior-hero-eyebrow {

        text-transform: uppercase;
    }
}
.interior-hero .interior-hero-inner {

    position: relative;
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-inner {

        display: flex;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-inner {

        height: 510px;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-inner {

        flex-direction: row-reverse;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-inner {

        flex-wrap: nowrap;
    }
}
.interior-hero > * {

    position: relative;
}
.interior-hero img {

    height: 225px;
}
.interior-hero img {

    width: 100%;
}
.interior-hero img {

    border-top-left-radius: 0.5rem;

    border-top-right-radius: 0.5rem;
}
.interior-hero img {

    object-fit: cover;
}
@media (min-width: 1024px) {

    .interior-hero img {

        height: 510px;
    }
}
.interior-hero .interior-hero-image {

    right: 0px;
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-image {

        position: absolute;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-image {

        height: auto;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-image {

        width: 65%;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-image {

        border-radius: 0px;
    }
}
.interior-hero .interior-hero-content {

    top: 0px;
}
.interior-hero .interior-hero-content {

    bottom: 0px;
}
.interior-hero .interior-hero-content {

    left: 0px;
}
.interior-hero .interior-hero-content {

    border-bottom-right-radius: 0.5rem;

    border-bottom-left-radius: 0.5rem;
}
.interior-hero .interior-hero-content {

    background-color: var(--bh-brand-primary-default);
}
.interior-hero .interior-hero-content {

    padding: 1.5rem;
}
.interior-hero .interior-hero-content {

    padding-top: 2rem;

    padding-bottom: 2rem;
}
.interior-hero .interior-hero-content {

    color: var(--neutral-white);
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-content {

        position: absolute;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-content {

        margin: auto;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-content {

        display: table;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-content {

        width: 528px;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-content {

        border-radius: 0.5rem;
    }
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-content {

        padding-left: 4rem;

        padding-right: 4rem;
    }
}
.interior-hero .interior-hero-title {

    margin-bottom: 1rem;
}
.interior-hero .interior-hero-title {

    font-family: var(--bh-ff-body);
}
.interior-hero .interior-hero-title {

    font-size: var(--fs-3xl);

    line-height: var(--lh-3xl);
}
@media (min-width: 1024px) {

    .interior-hero .interior-hero-title {

        font-size: var(--fs-4xl);

        line-height: var(--lh-4xl);
    }
}
.interior-hero .is-flipped .interior-hero-image {

    left: 0px;
}
.interior-hero .is-flipped .interior-hero-image {

    right: auto;
}
.interior-hero .is-flipped .interior-hero-content {

    right: 0px;
}
.interior-hero .is-flipped .interior-hero-content {

    left: auto;
}
@media (min-width: 1024px) {

    .interior-hero .is-flipped .interior-hero-content {

        position: absolute;
    }
}
[cloned-slot-name='cta-links'] {

    display: flex;

    flex-direction: column;

    flex-wrap: wrap;

    gap: 1rem;
}
@media (min-width: 1024px) {

    [cloned-slot-name='cta-links'] {

        flex-direction: row;
    }
}
.interior-hero.bg-white {

    background-color: var(--neutral-transparent);
}
.interior-hero.bg-white .interior-hero-inner {

    height: auto;
}
.interior-hero.bg-white .interior-hero-content {

    height: auto;
}
.interior-hero.bg-white .interior-hero-content {

    border-radius: 0px;
}
.interior-hero.bg-white .interior-hero-content {

    border-width: 0px;
}
.interior-hero.bg-white .interior-hero-content {

    border-bottom-width: 1px;
}
.interior-hero.bg-white .interior-hero-content {

    border-style: solid;
}
.interior-hero.bg-white .interior-hero-content {

    border-color: var(--bh-neutral-default);
}
.interior-hero.bg-white .interior-hero-content {

    background-color: var(--neutral-transparent);
}
.interior-hero.bg-white .interior-hero-content {

    padding: 0px;
}
.interior-hero.bg-white .interior-hero-content {

    padding-bottom: 1rem;
}
.interior-hero.bg-white .interior-hero-eyebrow {

    font-weight: var(--fw-bold);
}
.interior-hero.bg-white .interior-hero-content {

    position: relative;
}
.interior-hero.bg-white .interior-hero-content {

    width: 100%;
}
.interior-hero.bg-white .interior-hero-content {

    color: var(--neutral-black);
}
.interior-hero.bg-white [cloned-slot-name='cta-links'] {

    flex-direction: column;
}
`;